import { FormikHandlers } from 'formik';
import React, { FC } from 'react';
import NumericInput from '../../../../library/inputs/numeric/NumericInput';

interface Props {
  id: string;
  enabled: boolean;
  placeholder: string | undefined;
  value: number;
  touched: boolean | undefined;
  error: string | undefined;
  handleBlur: FormikHandlers['handleBlur'];
  handleChange: FormikHandlers['handleChange'];
  readOnlyMode?: boolean;
}

const NumericField: FC<Props> = ({
  id,
  enabled,
  placeholder,
  value,
  touched,
  error,
  handleBlur,
  handleChange,
  readOnlyMode,
}: Props) => {
  return (
    <NumericInput
      id={id}
      value={value}
      touched={touched}
      error={error}
      enabled={enabled}
      placeholder={placeholder}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default NumericField;
